var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesemty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.17 225.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 0.26,
    d: "M.13.13h155.91v225.36H.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75 25.64c0 3.13-2.54 5.67-5.67 5.67s-5.67-2.54-5.67-5.67 2.54-5.67 5.67-5.67 5.67 2.54 5.67 5.67",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75 25.64c0 3.13-2.54 5.67-5.67 5.67s-5.67-2.54-5.67-5.67 2.54-5.67 5.67-5.67 5.67 2.54 5.67 5.67Z",
    strokeWidth: 0.39,
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesemty);
export default __webpack_public_path__ + "static/media/accesemty.7baf56bbf860da2bf2208e9be199ae53.svg";
export { ForwardRef as ReactComponent };